<div class="dialog">

    <mat-toolbar color='primary' mat-dialog-title fxLayoutAlign="space-between">
        <h2 style='margin-top:3px;'>
            Profile
        </h2>

        <button class="button-close" mat-raised-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <mat-tab-group id='tabs'>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class='tab-icon'>fingerprint</mat-icon>
                Login
            </ng-template>

            <form class="form" name="accountForm" [formGroup]='accountForm' autocomplete="off">

                <div class='container'>

                    <div class="content-tab" class="account-login">

                        <div class='account-panel'>

                            <mat-form-field class="full-width" style='margin-top:40px;'>
                                <input matInput type="text" [errorStateMatcher]="matcher"
                                    [formControl]="accountForm.controls.displayName" placeholder="Nome"
                                    autocomplete="off">
                                <mat-error *ngIf="accountForm.controls.displayName.hasError('required')">
                                    Nome é obrigatório
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="full-width">
                                <input matInput type="email" [errorStateMatcher]="matcher"
                                    [formControl]="accountForm.controls.email" placeholder="Email" autocomplete="off">
                                <mat-error
                                    *ngIf="accountForm.controls.email.hasError('email') && !accountForm.controls.email.hasError('required')">
                                    Email inválido
                                </mat-error>
                                <mat-error *ngIf="accountForm.controls.email.hasError('required')">
                                    Email é obrigatório
                                </mat-error>
                            </mat-form-field>
                            <!--
                            <mat-form-field class="full-width">
                                <input matInput type="text" [errorStateMatcher]="matcher"
                                    [formControl]="accountForm.controls.phoneNumber" placeholder="Celular"
                                    autocomplete="off">
                                <mat-error *ngIf="accountForm.controls.phoneNumber.hasError('required')">
                                    Celular é obrigatório
                                </mat-error>
                            </mat-form-field>
  -->
                        </div>

                        <div class='account-panel'>
                            <div class="account-image">
                                <img [src]="_accountsService.storedImage" height="200"
                                    *ngIf="_accountsService.storedImage">
                                <input #file type="file" accept='image/png, image/jpg' style='display:none;'
                                    (change)="_accountsService.previewImage($event)" />
                                <hr>
                                <button mat-raised-button (click)='file.click()'>
                                    <mat-icon class='icon-add'>image_search</mat-icon>
                                </button>

                            </div>
                        </div>

                    </div>

                    <div class="action-tab" fxLayoutAlign="end" flex justify-content='flex-end'>
                        <div [ngClass]="{hidden: !spinner}">
                            <mat-spinner diameter="30"></mat-spinner>
                        </div>

                        <button mat-raised-button (click)='update()' [disabled]="accountForm.invalid">
                            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
                        </button>

                    </div>

                </div>

            </form>

        </mat-tab>


    </mat-tab-group>


</div>